import {
    CONTABLE_COMPROBANTES_REQUEST,
    CONTABLE_COMPROBANTES_SUCCESS,
    CONTABLE_COMPROBANTES_ERROR,
    CONTABLE_COMPROBANTES_CLEAR
} from '../types/contableComprobantesTypes';

const initialState = {
    comprobantes: [],
    page: 0,
    size: 15,
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    error: null,
    loading: false
}

/**
 * Algunos endpoints devuelven Page (trae totalElements/totalPages) y otros
 * devuelven Slice (solo content/number/size/numberOfElements/first/last, sin
 * totalElements). Cuando es Slice, se estima un total "de trabajo" usando el
 * flag `last` para que la paginacion no se quede pegada en 0 mientras aun hay
 * mas paginas. En cuanto `last === true`, el total queda exacto.
 */
const buildPageState = (payload) => {
    if (Array.isArray(payload)) {
        return {
            comprobantes: payload,
            page: 0,
            size: payload.length,
            totalElements: payload.length,
            totalPages: payload.length > 0 ? 1 : 0,
            numberOfElements: payload.length,
        };
    }

    const pageNumber = payload?.number || 0;
    const pageSize = payload?.size || 15;
    const numberOfElements =
        payload?.numberOfElements ?? (payload?.content ? payload.content.length : 0);

    // Respuesta tipo Page: trae totalElements real, se usa tal cual.
    if (payload && typeof payload.totalElements === "number") {
        return {
            comprobantes: payload?.content || [],
            page: pageNumber,
            size: pageSize,
            totalElements: payload.totalElements,
            totalPages: payload?.totalPages || 0,
            numberOfElements,
        };
    }

    // Respuesta tipo Slice: no trae totalElements, se estima con `last`.
    const isLast = payload?.last ?? numberOfElements < pageSize;
    const totalElements = isLast
        ? pageNumber * pageSize + numberOfElements
        : (pageNumber + 1) * pageSize + 1;

    return {
        comprobantes: payload?.content || [],
        page: pageNumber,
        size: pageSize,
        totalElements,
        totalPages: isLast ? pageNumber + 1 : pageNumber + 2,
        numberOfElements,
    };
};

export default function contableComprobantesReducer(state = initialState, action) {
    switch (action.type) {
        case CONTABLE_COMPROBANTES_REQUEST:
            return ({
                ...state,
                loading: action.payload
            });
        case CONTABLE_COMPROBANTES_SUCCESS: {
            const pageState = buildPageState(action.payload);

            return ({
                ...state,
                error: null,
                loading: false,
                ...pageState
            });
        }
        case CONTABLE_COMPROBANTES_ERROR:
            return ({
                ...state,
                loading: false,
                error: action.payload
            });
        case CONTABLE_COMPROBANTES_CLEAR:
            return initialState;
        default:
            return state;
    }
}
